import { CollectorsTab } from "./CollectorsTab"

export const BrokersTab = (props) => {
    return (<CollectorsTab 
                showApplicationType={true} 
                {...props} 
            />)
}